export default "$font-stack:    Helvetica, sans-serif\n$primary-color: #333\n\nbody\n  font: 100% $font-stack\n    color: $primary-color\n"